<template>
  <div class="admin-page">
    <h1>Admin Dashboard</h1>
    <p>Manage users and their access roles.</p>

    <div v-if="loading" class="loading">Loading users...</div>
    <div v-else>
      <table class="users-table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Role</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.uid">
            <td>{{ user.email || 'N/A' }}</td>
            <td>
              <select v-model="user.role" class="role-select">
                <option value="guest">Guest</option>
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </td>
            <td>
              <button class="btn btn-save" @click="saveRole(user)">Save Role</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'AdminPage',
  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch('admin/fetchUsers');
    });

    const users = computed(() => store.getters['admin/getUsers']);
    const loading = computed(() => store.getters['admin/isLoading']);

    const saveRole = (user) => {
      store.dispatch('admin/updateUserRole', {
        uid: user.uid,
        currentData: user,
        newRole: user.role
      });
      alert(`Role for ${user.email} updated to ${user.role}!`);
    };

    return {
      users,
      loading,
      saveRole
    };
  }
};
</script>

<style scoped lang="scss">
.admin-page {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(12px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.users-table th, .users-table td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.users-table th {
  background-color: rgba(6, 182, 212, 0.1);
  color: $cyan;
}

.users-table td {
  color: $white;
}

.users-table tr:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.role-select {
  padding: 8px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.3);
  color: $white;
}

.btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.btn-save {
  background-color: #007bff;
  color: white;
}
.btn-save:hover { background-color: #0056b3; }

.loading {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
